<div class="header">
  <h1 tabindex="0">{{ labels.pageHeading }}</h1>
  <hr />
</div>
<div class="row">
  <div class="col-sm-12 col-md-3 col-lg-3 roles-list-section">
    <h2 class="roles-header">{{ labels.roleListLabel }}</h2>
    <tmhna-portal-roles-permissions-list [editPermissions]="editPermissions"></tmhna-portal-roles-permissions-list>
    <hr class="d-mobile" />
  </div>
  <div class="col-sm-12 col-md-9 col-lg-9 customize-roles-section">
    <h2 class="customize-header">{{ labels.detailHeading }}</h2>
    <tmhna-portal-roles-permissions-details [editPermissions]="editPermissions" (isDirty)="saveChangesEvent($event)"></tmhna-portal-roles-permissions-details>
  </div>
</div>
<div class="overlay" *ngIf="!service.roleDetailsLoader">
  <kng-loader [state]="loaderState"></kng-loader>
</div>
